import React, {useCallback, useState} from "react";
import "./index.scss";
import {ModalPortal} from "features/components/modal";
import Title from "features/components/title";
import {__} from "services/i18n";
import Button from "features/components/button";
import {connect} from "react-redux";
import {commentSetShowAttachmentModal, commentStart} from "features/components/comment-field/reducer";
import CommentField from "features/components/comment-field";
import DocumentLoader from "features/components/document-loader";
import {RequiredValidator} from "services/utils/validations";
import {commentDataSelector, commentLoadingSelector} from "features/components/comment-field/selectors";

/* istanbul ignore next */
const mapStateToProps = state => ({
    value: commentDataSelector(state),
    loading: commentLoadingSelector(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    commentSetShowAttachmentModal,
    commentStart
};

export const CommentAttachmentModal = (props) => {
    const {commentSetShowAttachmentModal, commentStart, type, resource_id, value, loading} = props;
    const [attachment, setAttachment] = useState(null);

    const doPublish = useCallback(() => {
        if(!RequiredValidator(value)) return;
        commentStart({
            type: type,
            id: resource_id,
            attachment: attachment
        })
    }, [value, commentStart, type, resource_id, attachment]);


    const doCancel = useCallback(() => {
        commentSetShowAttachmentModal(false);
    }, [commentSetShowAttachmentModal]);


    return <ModalPortal className={"comment-attachment-modal"}>
        <Title size={34}>{__("modal.attachment-comment.title")}</Title>
        <CommentField type={type} resource_id={resource_id} hide_send={true} />
        <DocumentLoader
            onChange={setAttachment}
            text={__("modal.attachment-comment.attachment.title")}
            buttonTitle={__("modal.attachment-comment.attachment.button")}
            vertical={false}
            value={attachment}
        />
        <Button title={__("buttons.publish")} onClick={doPublish} disabled={!RequiredValidator(value)} status={loading ? "loading" : "default"} />
        <Button title={__("buttons.cancel")} onClick={doCancel} type={"outlined"}/>
    </ModalPortal>
}
export default connect(mapStateToProps, mapDispatchToProps)(CommentAttachmentModal);